module.exports = __webpack_public_path__ + "img/done_dark.8d8132b4.svg";